import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const initialState = {
  isSidebarOpen: true,
  indexOfOpenAccordion: -1
};

const sidebarTogglingSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
      state.indexOfOpenAccordion = state.isSidebarOpen
        ? state.indexOfOpenAccordion
        : -1;
    },
    onToggleAccordion: (state, { payload }) => {
      state.indexOfOpenAccordion =
        payload === state.indexOfOpenAccordion ? -1 : payload;

      if (!state.isSidebarOpen && state.indexOfOpenAccordion > -1) {
        state.isSidebarOpen = true;
      }
    },
    closeSideBarAccordion: (state) => {
      state.indexOfOpenAccordion = -1;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const { actions, reducer } = sidebarTogglingSlice;

export const { toggleSidebar, onToggleAccordion, closeSideBarAccordion } =
  actions;

export default reducer;
